<ul class="h-full flex gap-8">
    <li *ngFor="let item of menu">
        <a [routerLink]="[item.route]" routerLinkActive="active">
            {{ item.name | translate }}
        </a>
    </li>
</ul>
